import gdpr from './gdpr';

const middlewares = [gdpr];

export default middlewares;
